import { Patient } from "../../../api/patient.types";
import { PatientsByphoneAddedAction } from "./patients.byphone.added.types";

export const patientsByphoneAddedRequest = (): PatientsByphoneAddedAction => ({ type: 'PATIENTS_BYPHONE_ADDED_REQUEST' })

export const patientsByphoneAddedSuccess = (users: Patient[]): PatientsByphoneAddedAction => ({ type: 'PATIENTS_BYPHONE_ADDED_SUCCESS', params: { users } })

export const patientsByphoneAddedFailure = () => ({ type: 'PATIENTS_BYPHONE_ADDED_FAILURE' } as const)